"use strict";

export function initInScope ($scope) {
    let $cookieBtn =  $scope.find('.js-cookie-modal-open');
    $cookieBtn.on('click', (e) =>{
        e.preventDefault();
        window.et_forceShowCookieOptin = true;
        et_showOptIn();
    });
}